import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import Button from '@material-ui/core/Button';
import services from '../services';
import { tagSchemaObject } from '../TagAmendmentSchema'
import { Fields, validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import CardActions from '@material-ui/core/CardActions';
import Table from '@material-ui/core/Table';
import { trackPromise } from 'react-promise-tracker';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import _, { initial } from 'lodash';
import swal from 'sweetalert';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import moment from 'moment';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import Autocomplete from '@material-ui/lab/Autocomplete';
const screenCode = 'TAGAMENDMENT';


const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        fontSize: 10,

    },
    tabroot: {
        flexGrow: 1
    },
    title: {
        fontSize: 12,
    },
    pos: {
        marginBottom: 12,
    },
    btncolor: {
        background: '#10BA57'
    },
    btnroot: {
        backgroundColor: '#10BA57',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: "#049C44"
        }

    },
    btnrootdel: {
        backgroundColor: '#FF0000',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: " #e60000"
        }

    },
    colorscheme: {
        color: '#10BA57',
    },

    card: {
        alignContent: 'center'
    },

    label: {
        textTransform: 'capitalize',
    },
    rootpaper: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    autoComplete:{
        alignItems:'center'
    }
}));

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        "aria-controls": `scrollable-auto-tabpanel-${index}`
    };
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};





export function LeafAmendment(props) {

    const classes = useStyles();
    const schema = Joi.object(tagSchemaObject).options({ allowUnknown: true })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [groups, setGroups] = useState();
    const [factoriesData, setFactoriesData] = useState();
    const [collectionPoint, setCollectionPoint] = useState();
    const [searchData, setSearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        tag: " ",
        date: " "
    });
    const [initialTagDetails, setInitialTagDetails] = useState({})
    const [tagDetails, setTagDetails] = useState({
        routeCode:"",
        routeName: "",
        date: "",
        customerNo:"",
        customerID:"",
        cardNumber: "",
        supplierRegNo: "",
        grossAmount: "",
        actualAmount: "",
        netAmount: "",
        createdDate:"",
        deductions: []
    });

    const [updateTagDetails, setUpdateTagDetails] = useState({
        routeCode:"",
        routeName: "",
        date: "",
        customerNo:"",
        customerID:"",
        cardNumber: "",
        supplierRegNo: "",
        grossAmount: "",
        actualAmount: "",
        netAmount: "",
        createdDate:"",
        deductions: []
    });

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Success"
    })

    const [chipData, setChipData] = React.useState([

    ]);
    const [TagInfo, setTagInfo] = React.useState({
        newDate: "",
        collectionPointID: ""
    });
    const [customers, setCustomers] = useState([]);

    const [errors, setErrors] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [value, setValue] = React.useState(0);
    const [tabSectionVisibility, setTabSectionVisibility] = React.useState({
        isFeild: false,
        isFacGeneral: false,
        isFacException: false
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);

        if (value == 0) {
            setTabSectionVisibility({
                isFeild: true,
                isFacGeneral: false,
                isFacException: false
            })
        }
    };
    const [deductionView, setDeductionView] = React.useState([]);
    const [deductionTemplate, setDeductionTemplate] = React.useState({
        deductions:[]
    });
    const [viewTable, setViewTable] = React.useState(true);

    useEffect(() => {
        getPermissions();
        var datex = (new Date().toISOString()).split("T");
        setSearchData({
            ...searchData,
            date: datex[0]
        });

    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [searchData.groupID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTAGAMENDMENT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await services.getGroupsForDropdown()
        setGroups(result)
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(searchData.groupID);
        setFactoriesData(opEntities);
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clear();
            setViewTable(true)
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        setTimeout(() => {
            modalDismissHandler();
        }, 3000);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function clear() {
        setTagDetails({
            routeCode: "",
            date: "",
            cardNo: "",
            supplierRegNo: "",
            grossWeight: "",
            routeName: "",
            newDate: "",
            customerNo: "",
            deductions: "",
            createdDate:""
        });


        setSearchData({
            groupID: "",
            operationEntityID: "",
            tag: "",
            date: ""
        });

        setChipData([]);
    }


    function renderDropDown(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items;
    }


    function handleGroupChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            groupID: target.value
        });
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            operationEntityID: target.value,
        });
    }

    function handleTagChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            tag: target.value,
        });
    }

    function handleDateChange(target) {
        setTagInfo({
            ...TagInfo,
            newDate: target.value,
        });
    }

    function handleSearchDateChange(target) {
        setSearchData({
            ...searchData,
            date: target.value,
        });
    }

    async function getCustomers(routeID){
        var response = await services.getCustomersFromCollectionPoint(routeID);
        setCustomers(response)
    }

    async function handleSubmit() {
       
        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        var response = await services.getTagDetails(searchData);
        if (response != null || response != undefined) {
            setViewTable(false);
            setInitialTagDetails(response);

            setTagDetails(response);
            setUpdateTagDetails({
                ...updateTagDetails,
                routeCode:response.routeCode,
                routeName:response.routeName,
                grossAmount:response.grossAmount,
                actualAmount:response.actualAmount,
                netAmount:response.netAmount,
                cardNumber:response.cardNumber,
                createdDate:response.createdDate,
                customerID:response.customerID
            })
          
          
            setDeductionView(response.productDeduction)
            setChipData(response.productDeduction);
            getCustomers(response.collectionPointID);
            getDeductionTemplates(searchData.groupID, searchData.operationEntityID,response.collectionPointID,response.productDeduction)
           
       
        }else{
            setViewTable(true);
        }
    }

  
   
    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, tagSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setErrors(error);
    }

 

    function handleUpdateChange(e){
        var totDeductions =   CalculateWeighment();
        
        if(e.target.name === "actualAmount"){
            let amount = parseFloat(e.target.value);
            if(amount > 0 && amount < 1000 ){
            setUpdateTagDetails({
                ...updateTagDetails,
                grossAmount: (Math.round(amount)),
                actualAmount:amount ,
                netAmount: (amount-(totDeductions))
            })
        }
        }else{
            swal('Amounts must be greater than 0 and smaller than 1000');
            setUpdateTagDetails({
                ...updateTagDetails,
                [e.target.name]:e.target.value
            })
        }
    }
    
    function handleCustomerAccChange(data){
    
        setUpdateTagDetails({
            ...updateTagDetails,
            customerNo:data.customerRegistrationNumber,
            cardNumber:data.cardNumber,
            customerID:data.customerID
        })
    }

     const updateNewDeductionArray=((id,e)=>{
        {
            e.preventDefault();
          
            
            var itemArray=[];
            itemArray=deductionTemplate.deductions;
            itemArray.map((row) => {
                if(row.deductionTemplateID ===id){
                    row.updatedAmount = parseFloat(e.target.value);
                }
            });


            calculateNetAmount(itemArray);

            setDeductionTemplate({
                ...deductionTemplate,
                deductions:itemArray
            });
        }
     })

     function calculateNetAmount(itemArray){

        var totalDeduction = 0;
        itemArray.map((row) => {
            totalDeduction= totalDeduction +parseFloat(row.updatedAmount);
        });

        if(updateTagDetails.actualAmount>= totalDeduction){
         setUpdateTagDetails({
             ...updateTagDetails,
            netAmount:updateTagDetails.grossAmount - totalDeduction
         })}
         else{
             swal("Deductions cannot exceed actual amount");
         }
     }

    async function getDeductionTemplates(gpID,entityID,collectionPointID,deductions) {
        let res = await services.getDeductionTemplate(parseInt(gpID),entityID,collectionPointID.toString());
     
      
        if (res != null) {
           
            var itemArray=[];
           
            res.map((row) => {
                if(row.isActive){
                     let obj = deductions.find(o => o.deductionTemplateID == row.deductionTemplateID);
                 
                    if(obj === undefined){
                       
                        itemArray.push({
                            productDeductionID :"00000000-0000-0000-0000-000000000000",
                            deductionTemplateID :row.deductionTemplateID,
                            deductionAmount :0,
                            updatedAmount :0,
                            deductionTypeName : row.deductionTypeName,
                            deductionTypeID : row.deductionTypeID
                        });
                       
                    }else{
                        
                        itemArray.push({
                            productDeductionID :obj.productDeductionID,
                            deductionTemplateID :obj.deductionTemplateID,
                            deductionAmount :obj.deductionAmount,
                            updatedAmount :obj.deductionAmount,
                            deductionTypeName : obj.deductionTypeName,
                            deductionTypeID : obj.deductionTypeID
                        });
                    }
                }
              
            });  

          

            setDeductionTemplate({
                ...deductionTemplate,
                deductions:itemArray
            });
        }

    }

    async function handleSubmitApproval(){
        var totDeductions =   CalculateWeighment();

        var customerChanged = !(initialTagDetails.cardNumber == updateTagDetails.cardNumber);
        var sameCustomer = !(initialTagDetails.cardNumber = updateTagDetails.cardNumber);
        var dateChanged = !(initialTagDetails.createdDate === updateTagDetails.createdDate);
        var weightChanged = !(parseFloat(initialTagDetails.actualAmount) == parseFloat(updateTagDetails.actualAmount) && parseFloat(initialTagDetails.netAmount) == parseFloat(updateTagDetails.netAmount)); 


        let newLeafAmendRequest = {
            operationEntityID: parseInt(searchData.operationEntityID),
            tagNumber: searchData.tag,
            collectionPointID : initialTagDetails.collectionPointID,
            customerID: updateTagDetails.customerID,
            cardNumber: updateTagDetails.cardNumber,
            grossAmount: (Math.round(parseFloat(updateTagDetails.grossAmount) )),
            actualAmount:parseFloat(updateTagDetails.grossAmount) ,
            netAmount: (parseFloat(updateTagDetails.grossAmount)-(totDeductions)),
            totalDeduction: totDeductions,
            registrationNumber:updateTagDetails.customerNo,
            newDate: updateTagDetails.createdDate,
            newDeduction :deductionTemplate.deductions,
        }

        let formData={
            isCustomerChanged:customerChanged,
            isDateChanged :dateChanged,
            isWeightChanged :weightChanged,
            userID :1,
            previoseDate:tagDetails.date,
            oldCollectionRequest :initialTagDetails,
            newCollectionRequest :newLeafAmendRequest
        }

        console.log("customerChanged:", customerChanged);
        console.log("deductions and shit:", newLeafAmendRequest);
        console.log("final form to be sent to api", formData);
       
        var totalDeduction = 0;
        newLeafAmendRequest.newDeduction.map((row) => {
            totalDeduction = totalDeduction + parseFloat(row.updatedAmount);
        });

        if(newLeafAmendRequest.actualAmount >= totalDeduction){
        
        var response =  await services.saveToApproval(formData);
      
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
        }
        else{
            swal("Deduction amount cannot exceed actual amount");
        }
    }


    function CalculateWeighment(){
        var totalDeduction = 0;
        deductionTemplate.deductions.map((row) => {
            totalDeduction= totalDeduction +parseFloat(row.updatedAmount);
        });
        return totalDeduction;
    }

    return (
        <Fragment>
            {/* <Paper className={classes.tabroot}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab label="Feild"  {...a11yProps(0)} />
                    <Tab label="Factory" {...a11yProps(1)} />

                </Tabs>

            </Paper>

            <TabPanel value={value} index={0}> */}

                <Card className={classes.root} >
                  
                        <CardContent>
                            <PageHeader
                                title={"Field Tag Amendment"}
                                isButtonEnable={false}
                                buttonText="Back to Listing"
                                path="/groups"
                            />
                            <Grid container spacing={3}>

                                <Grid item xs={3} >
                                    <TextField
                                        id="groupID"
                                        name="groupID"
                                        select
                                        fullWidth
                                        label="Group *"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleGroupChange(e.target)}
                                    >
                                        <MenuItem value="0">--Select Group Name--</MenuItem>
                                        {renderDropDown(groups)}
                                    </TextField>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </Grid>

                                <Grid item xs={3}>
                                    <TextField
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        select
                                        fullWidth
                                        label="Factory *"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        onChange={(e) => handleOperationEntityChange(e.target)}
                                        value={searchData.operationEntityID}
                                    >
                                        <MenuItem value="0">--Select operationEntity Name--</MenuItem>
                                        {renderDropDown(factoriesData)}
                                    </TextField>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </Grid>

                                <Grid item xs={3}>
                                    <TextField
                                        id="tag"
                                        name="tag"
                                        fullWidth
                                        label="TagNumber *"
                                        onChange={(e) => handleTagChange(e.target)}
                                        value={searchData.tag}
                                    >
                                    </TextField>
                                    {errors["tag"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["tag"]}</FormHelperText>}
                                </Grid>


                                <Grid item xs={3}>
                                    <TextField
                                        id="date *"
                                        fullWidth
                                        type="date"
                                        label="Date"
                                        onChange={(e) => handleSearchDateChange(e.target)}
                                        value={searchData.date}
                                    >

                                    </TextField>
                                </Grid>

                                <Grid container justify="flex-end">
                                    <Button
                                        onClick={() => handleSubmit()}
                                        variant="contained"
                                        className={classes.btnroot}
                                    > Search</Button>
                                </Grid>

                            </Grid>
                            <br />
                            <br />

                            <TableContainer component={Paper} hidden={viewTable}>
                                <Table className={classes.table} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{background:"lightgreen"}} align="center">Field Name</TableCell>
                                            <TableCell style={{background:"lightgreen"}} align="center">Original Record</TableCell>
                                            <TableCell style={{background:"lightgreen"}} align="center">Updated Record</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                              
                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                               Route Code
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled value={tagDetails.routeCode} size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled name="routeCode"  value={updateTagDetails.routeCode} size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                            Route Name
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled value={tagDetails.routeName} size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled  name="routeName" value={updateTagDetails.routeName} size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                            Date
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" type="date" disabled value={(tagDetails.createdDate).split("T")[0]} size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">

                                                <TextField fullWidth inputProps={{ style: { textAlign: 'center' } }} id="outlined-basic" disabled type="date" name="createdDate" value={(updateTagDetails.createdDate).split("T")[0]} size="small" label="" variant="outlined" />

                                            </TableCell>
                                        </TableRow>
                                   
                                         <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                                Customer Registration No
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled name="customerNo" value={tagDetails.customerNo} size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell classes={classes.autoComplete} >
                                                <Autocomplete
                                                    required
                                                    size="small"
                                                    name="customerNo"
                                                    onChange={(e,value) => handleCustomerAccChange(value)}
                                                    classes={classes.autoComplete}
                                                    options={customers}
                                                    getOptionLabel={(option) => option.customerName + "--" + option.customerRegistrationNumber}
                                                    renderInput={(params) => <TextField {...params} label="Customer Account" variant="outlined" id="outlined-basic" name="customerNo" />}
                                                />
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell  align="center" component="th" scope="row">
                                                Card No
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}} id="outlined-basic" disabled name="cardNo" value={tagDetails.cardNumber} size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}} onChange={(e)=>handleUpdateChange(e)} id="outlined-basic" disabled  name="cardNo" value={updateTagDetails.cardNumber} size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                               Actual Amount
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{maxLength: 3, style: { textAlign: 'center' }}}  id="outlined-basic" disabled name="actualAmount"  value={tagDetails.actualAmount}  size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{maxLength: 3, style: { textAlign: 'center' }}} onChange={(e)=>handleUpdateChange(e)}  id="outlined-basic" name="actualAmount"  value={updateTagDetails.actualAmount}  size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>
                                        
                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                                Gross Weight
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{maxLength: 3, style: { textAlign: 'center' }}}  id="outlined-basic"  disabled name="grossWeight" value={tagDetails.grossAmount}  size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{maxLength: 3,style: { textAlign: 'center' }}} id="outlined-basic" disabled name="grossAmount"  value={updateTagDetails.grossAmount} size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>

                                        

                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                              Net Amount
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{style: { maxLength: 3, textAlign: 'center' }}}  id="outlined-basic" disabled name="netAmount"  value={tagDetails.netAmount}  size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{maxLength: 3,style: { textAlign: 'center' }}}  id="outlined-basic" name="netAmount" disabled  value={updateTagDetails.netAmount}  size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                        <TableCell style={{background:"#f08080"}} colSpan={3} align="center" component="th" scope="row" fontSize="10">
                                            Deductions 
                                            </TableCell>
                                        </TableRow>

                                        {deductionTemplate.deductions.map((row) => (
                                            <TableRow key={row.name}>
                                                <TableCell align="center" component="th" scope="row">
                                                    {row.deductionTypeName}
                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextField fullWidth type="number" disabled inputProps={{maxLength: 3, style: { textAlign: 'center' }}}  id="outlined-basic" size="small" value={row.deductionAmount} label="" variant="outlined" />

                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextField fullWidth  type="number"  inputProps={{ maxLength: 3, style: { textAlign: 'center' }}} value={row.updatedAmount}  onChange={(event)=>updateNewDeductionArray(row.deductionTemplateID,event)} id="outlined-basic" size="small" label="" variant="outlined" />
                                                </TableCell>
                                            </TableRow>
                                        ))}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <CardActions className={classes.card} alignContent={'right'} hidden={viewTable}>
                    <Grid container justify="flex-end" >
                        <Button
                             onClick={() => handleSubmitApproval()}
                            variant="contained"
                            className={classes.btnroot}
                        > Update</Button>&nbsp;
                                       </Grid>

                </CardActions>


                        </CardContent>

                 

                    <MessageModal
                        hidden={messageModel.hidden}
                        messageType={messageModel.type}
                        messageDescription={messageModel.disciption}
                        clicked={modalDismissHandler}
                    />
                </Card>
            {/* </TabPanel>
            <TabPanel value={value} index={1}>
                <FactoryGeneral /> 
            </TabPanel> 
            */}


        </Fragment>
    );
}